import {
  Box,
  Button,
  Grid,
  PageHeroActions,
  PageHeroBackdrop,
  PageHeroFrame,
  PageHeroText,
  Stack,
  Text,
} from "@generalapplications/ui";

import { ResponsiveImage } from "@/app/common/components/composite/media/ResponsiveImage";
import { Reveal } from "@/app/common/components/composite/motion/Reveal";
import { HeroSystemVisual } from "@/app/features/diagrams/components/heroSystem/HeroSystemVisual";
import { homePage } from "@/content/home";
import { routes, sectionIds } from "@/app/common/functions/routes/routes";
import { formatText } from "@/app/common/functions/format/formatText";

/** The home page's banner: the claim, the two ways in, and the system map. */
export function Hero() {
  return (
    <Reveal>
      {/* The feature floor: most of the first screen, with the diagram
          beside the words; every other page's banner stands on `page`. */}
      <PageHeroFrame minHeight="feature" focus="right">
        <PageHeroBackdrop>
          <ResponsiveImage
            src={homePage.image}
            width={1200}
            height={630}
            eager
          />
        </PageHeroBackdrop>
        <Box width="full">
          <Grid columns={{ base: 1, lg: 2 }} gap="xxl" align="center">
            <PageHeroText title={formatText(homePage.hero.headline)}>
              <Box paddingTop="lg">
                <Stack gap="lg">
                  {homePage.hero.copy.map((paragraph) => (
                    <Text key={paragraph} variant="lead">
                      {formatText(paragraph)}
                    </Text>
                  ))}
                </Stack>
              </Box>
              <PageHeroActions>
                <Button href={`#${sectionIds.capabilities}`} size="lg">
                  {homePage.hero.primaryCta}
                </Button>
                <Button href={routes.contact} size="lg" variant="outline">
                  {homePage.hero.secondaryCta}
                </Button>
              </PageHeroActions>
            </PageHeroText>
            <Reveal delay={0.15} y={24}>
              <HeroSystemVisual />
            </Reveal>
          </Grid>
        </Box>
      </PageHeroFrame>
    </Reveal>
  );
}
